import type { Coordinates } from 'maps/types'

export function getCurrentPosition(): Promise<Coordinates> {
	if (!navigator.geolocation) {
		return Promise.reject(
			new Error('Geolocation is not supported by your browser')
		)
	}

	return new Promise((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(
			(position) => {
				const { latitude, longitude } = position.coords
				resolve({ lat: latitude, lng: longitude })
			},
			(err) => reject(new Error(`ERROR(${err.code}): ${err.message}`))
		)
	})
}
